import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-short-link-redirect-page',
  standalone: true,
  template: `
    <div class="flex min-h-screen items-center justify-center bg-white px-4">
      <p class="text-sm text-slate-500">Opening form…</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortLinkRedirectPage implements OnInit {
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const code = this.route.snapshot.paramMap.get('code')?.trim();
    if (!code) {
      return;
    }
    const base = environment.baseUrl.replace(/\/$/, '');
    window.location.replace(`${base}/api/public/short-links/${encodeURIComponent(code)}`);
  }
}
